"use strict";

/*
 * # Example of Usage:
 *
 * 1 - Simple usage:
 *    <BooleanInput
 *      type="radioButton"
 *      onClick={this.radioButtonOnClick}
 *      checked={this.state.checked}>
 *
 * 2 - Component with children:
 *    <BooleanInput type="checkbox" onClick={this.radioButtonOnClick} checked={this.state.checked}>
 *      <span className="p-r l-10">Example Text</span>
 *    </BooleanInput>
 *
 * 3 - Component with border:
 *    <BooleanInput type="radioButton" border="thin" onClick={this.radioButtonOnClick} checked={this.state.checked} />
 *    <BooleanInput type="checkbox" border="thick" onClick={this.radioButtonOnClick} checked={this.state.checked} />
 *
 * 4 - Component with color:
 *    <BooleanInput type="checkbox" color="green" onClick={this.radioButtonOnClick} checked={this.state.checked} />
 *    <BooleanInput type="radioButton" color="blue" onClick={this.radioButtonOnClick} checked={this.state.checked} />
 *    <BooleanInput type="radioButton" color="grey" onClick={this.radioButtonOnClick} checked={this.state.checked} />
 *
 * 5 - Full usage:
 *    <BooleanInput type="checkbox" border="thin" color="green" onClick={this.radioButtonOnClick} checked={this.state.checked}>
 *      <span className="p-r r-10">Example Text</span>
 *    </BooleanInput>
 *
 * Note: You can not use RadioButton with thin border
 */

var cx = require("classnames");

var BooleanInputWrapper = React.createClass({
  propTypes: {
    border: React.PropTypes.oneOf(["thin", "thick"]),
    checked: React.PropTypes.bool,
    color: React.PropTypes.oneOf(["green", "blue", "grey", "doveGray"]),
    onClick: React.PropTypes.func,
    type: React.PropTypes.oneOf(["radioButton", "checkbox"]).isRequired
  },
  getDefaultProps: function() {
    return {
      checked: false,
      placement: "left",
      border: "thin",
      color: "blue",
    };
  },
  shouldComponentUpdate: function(nextProps, nextState) {
    return this.props.checked != nextProps.checked;
  },
  handleClick: function() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  },
  getBaseClassName: function() {
    return {
      radioButton: "RadioButton",
      checkbox: "Checkbox"
    };
  },
  render: function(){
    return (
      <div>
        <CustomBooleanInput {...this.props} baseClassName={this.getBaseClassName()[this.props.type]}/>
      </div>
    );
  }
});

const CustomBooleanInput = (props) => {
  if (props.border == "thick") {
    return <BooleanInputThick {...props} />;
  } else {
    return <BooleanInputThin {...props} />;
  }
};

const BooleanInputThick = (props) => {
  var booleanInputClassName = [
    "lh-14",
    "custom" + props.baseClassName + "--thick",
    "custom" + props.baseClassName + "--" + props.color,
    { [`custom${props.baseClassName}--checked`]: props.checked }
  ];

  return (
    <BooleanInput
      baseClassName={props.baseClassName}
      className={booleanInputClassName}
      onClick={props.onClick} />
  );
};

const BooleanInputThin = (props) => {
  var booleanInputClassName = [
    "custom" + props.baseClassName + "--thin",
    {
      [`custom${props.baseClassName}--checked`]: props.checked,
      [`custom${props.baseClassName}--${props.color}`]: props.checked
    }
  ];

  return (
    <BooleanInput
      baseClassName={props.baseClassName}
      className={booleanInputClassName}
      onClick={props.onClick} />
  );
};

const BooleanInput = (props) => {
  var inputClassName = cx(
    "custom" + props.baseClassName,
    props.className
  );

  return (
    <div className={"custom" + props.baseClassName + "Wrapper noselect"} onClick={props.onClick}>
      <div className={inputClassName}></div>
    </div>
  );
};

module.exports = BooleanInputWrapper;



// WEBPACK FOOTER //
// ./app/shared/components/BooleanInput/boolean-input.jsx